export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrada:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Continuar"])}
}